import React from 'react';
import './css/Dialogo.css';

export default class Dialogo extends React.Component{
  constructor(props) {
    super(props);
    this.state = {

    }
  }

  render(){
    const {titulo, children} = this.props;
    return(
      <div className="DialogoContainer">
        <span className="DialogoTitulo">{titulo}</span>
        <hr color="white" width="90%"/>
        <span className="DialogoCuerpo">
          {children}
        </span>
      </div>
    );
  }
}
